import type { LangCode, NewDayTripPlan_Default_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductNewDayTripPlanFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/new/use-init";
import { DayTripPlanFormMain } from "../_shared/components/root";
import { dayTripPlanCategoriesAndManagerStore } from "../_shared/store/categories";
import { HeaderActions } from "./components/header/actions";

type Props = {
	activeLangCode: LangCode;
	serverModel: NewDayTripPlan_Default_EditPageQuery;
};

export const NewDayTripPlanEditPresenter = ({ activeLangCode, serverModel }: Props) => {
	const init = useInitialized({
		serverModel,
	});
	const { categoryManagerStore } = dayTripPlanCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const planName = init.viewModel.name.value;

	return (
		<ProductNewDayTripPlanFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="新しいプランの編集"
					activeLangCode={activeLangCode}
					rightChildren={<HeaderActions />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={planName} />

					<DayTripPlanFormMain dayTripPlanCategoriesAndManagerStore={dayTripPlanCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductNewDayTripPlanFormModelContextProvider>
	);
};

NewDayTripPlanEditPresenter.displayName = "NewDayTripPlanEditPresenter";
